import { FunctionComponent } from "react";

import { Tooltip } from "@/components/Tooltip/Tooltip";

import { CategoryReasoningKind, CategoryReasoningPopover } from "./CategoryReasoningPopover";

/**
 * Table-cell trigger for a company / persona segment column: shows the resolved
 * category name and, on hover, the beautified {@link CategoryReasoningPopover}
 * (verdict + reasoning, PREC-3499). Renders a muted dash when there is no
 * category.
 */
export const CategorySegmentCell: FunctionComponent<{
	kind: CategoryReasoningKind;
	categoryName?: string | null;
	reasoning?: string | null;
	/** Raw score for the prio badge: companyScore for company, personaScore for persona. */
	prioScore?: string | null;
}> = ({ kind, categoryName, reasoning, prioScore }) => {
	if (!categoryName) {
		return <span className="text-sm text-gray-400">-</span>;
	}

	return (
		<Tooltip
			content={
				<CategoryReasoningPopover
					categoryName={categoryName}
					kind={kind}
					prioScore={prioScore}
					reasoning={reasoning}
				/>
			}
			delay={300}
			disabled={!reasoning}
			panel
		>
			<span className="text-sm text-gray-700">{categoryName}</span>
		</Tooltip>
	);
};
